<template>
  <section class="graph-section">
    <img
      class="graph-section__img"
      :src="`${baseUrl}images/charts/${route.params.page}${
        tvaMq === 'mobile' ? '-m' : tvaMq === 'tablet' ? '-t' : ''
      }.svg`"
      :alt="alt"
    />
  </section>
</template>

<script setup>
import { inject } from "vue";
import { useRoute } from "vue-router";

defineProps({
  alt: String,
});

const route = useRoute();
const baseUrl = inject("$baseUrl");
const tvaMq = inject("$tvaMq");
</script>

<style lang="scss" scoped>
.graph-section {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: var(--page-color);
  position: relative;
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background: #22222240;
  }

  &__img {
    display: block;
    width: 100%;
    max-width: 1200px;
    z-index: 1;
  }
}
</style>
